module.exports = __webpack_public_path__ + "static/media/logo155.7c7377c3.png";